import * as React from 'react';

const SvgCommentAddFill = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M10 22h2.11l3.36-4H22V2H2v16h8v4ZM8 11V9h3V6h2v3h3v2h-3v3h-2v-3H8Z" })
);

export { SvgCommentAddFill as default };
//# sourceMappingURL=CommentAddFill.es.js.map
